import React, { useCallback, useEffect, useState } from 'react'
import TestTakerHeader from 'pages/School/TestTakers/TestTakerHeader'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { ReactComponent as GoHomeIcon } from 'assets/icons/GoHome.svg';
import { Title } from 'components'
import { useNavigate } from 'react-router-dom';
import { app } from './routes';
import { Can } from 'components/Permissions';
import { alerts as alertsKeys } from 'keys'
import { SvgIcon } from '@mui/material';
import { useAlert } from 'components/Alerts/hooks';
import AssessmentDetails from 'pages/School/Assessment/AssessmentDetails'

const WrapAppRoute = (props) => {
    const { isGeneralPage, exitAlert, feature, children, hideHeader, title, featurePath, breadcrumbs } = props
    const { assessment } = useSelector(state => state.assessment)
    const { alerts } = useSelector(state => state.general)
    const { setAlerts } = useAlert()
    const navigate = useNavigate()

    const [openExitScreenAlert, setOpenExitScreenAlert] = useState(false)

    const childrenWithProps = () => {
        return React.Children.map(children, child => {
            if (React.isValidElement(child)) {
                return React.cloneElement(child, {
                    ...props,
                })
            }
            return child
        })
    }

    useEffect(() => {
        return (() => {
            setOpenExitScreenAlert(false)
        })
    }, [])


    const closeExitScreenAlert = useCallback(() => {
        setAlerts(alertsKeys.exitScreen, false)
    }, [])

    const acceptExitScreenAlert = useCallback(() => {
        closeExitScreenAlert()
        navigate(app.allAssessments)
    }, [])

    return (
        <>
            {/* <Can I="manage" a="student">
                <div className='go-home-icon' onClick={() => setOpenExitScreenAlert(true)}>
                    <SvgIcon component={GoHomeIcon} inheritViewBox />
                </div>
            </Can> */}
            {exitAlert && alerts[alertsKeys.exitScreen].open && <props.exitAlert close={closeExitScreenAlert} accept={acceptExitScreenAlert} />}
            {(title && !breadcrumbs) && <Title feature={feature} title={title} featurePath={featurePath} />}
            {!isGeneralPage && !hideHeader &&
                <>
                    {isEmpty(assessment) ?
                        <TestTakerHeader /> :
                        <AssessmentDetails />
                    }
                </>
            }
            {childrenWithProps()}
        </>
    )

}

export default WrapAppRoute